import _Vue from 'vue'
import pako from 'pako'
import { Buffer } from 'buffer'

/**
 * HTML文字列API送信時のWAF回避策等、DB登録時に使用
 */
export default {
  install(Vue: typeof _Vue): void {
    /**
     * 文字列 → gzip圧縮 → base64文字列
     * @param str string
     */
    const stringToBase64 = async function (str: string): Promise<string | null> {
      try {
        // gzip圧縮から、base64メッセージエンコード
        const gzip = (data: Uint8Array): Promise<ArrayBuffer> => pako.gzip(data).buffer
        const uintArray: Uint8Array = new TextEncoder().encode(str)
        const arrayBuffer = await gzip(uintArray)

        return Buffer.from(arrayBuffer).toString('base64')
      } catch {
        // エラー時はnullを返す
        return null
      }
    }

    /**
     * base64文字列 → gzip解凍 → 文字列
     * @param str string
     */
    const base64ToString = async function (str: string): Promise<string | null> {
      try {
        // メッセージが base64 形式でない場合は、強制的にエラーを発生させ、デコード処理を行わない
        window.atob(str)
        // base64メッセージデコードから、gzip解凍
        const ungzip = (data: Uint8Array): Promise<ArrayBuffer> => pako.ungzip(data).buffer
        const uintArray: Uint8Array = Buffer.from(str, 'base64')
        const arrayBuffer = await ungzip(uintArray)

        return new TextDecoder().decode(arrayBuffer)
      } catch {
        // エラー時はnullを返す
        return null
      }
    }

    Vue.prototype.$compress = { stringToBase64, base64ToString }
  },
}

/**
 * インターフェース定義
 */
declare module 'vue/types/vue' {
  interface Vue {
    $compress: {
      stringToBase64: (str: string) => Promise<string | null>
      base64ToString: (str: string) => Promise<string | null>
    }
  }
}
